import apiServices from "../apiServices";
import { validateOrThrowApiResponse } from "../response-validator";

type MatchingPayloadItem = {
    id?: number | string;
    no: number;
    keyword: string;
    matching_word: string;
    hint?: string | null;
    sound_keyword?: string | null;
    image_keyword?: string | null;
    sound_matching_word?: string | null;
    image_matching_word?: string | null;
    sound_hint?: string | null;
    image_hint?: string | null;
};

type MatchingSkillPayload = {
    skill_listening_speaking?: boolean;
    skill_lang_nature?: boolean;
    skill_reading?: boolean;
    skill_writing?: boolean;
};

type CreateMatchingPayload = MatchingSkillPayload & {
    gameId: number | string;
    matchings: MatchingPayloadItem[];
};

type GetMatchingByIdPayload = {
    gameId: number | string;
};

type UpdateMatchingPayload = MatchingSkillPayload & {
    matchingId: number | string;
    keyword?: string;
    matching_word?: string;
    no?: number;
    hint?: string | null;
    sound_keyword?: string | null;
    image_keyword?: string | null;
    sound_matching_word?: string | null;
    image_matching_word?: string | null;
    sound_hint?: string | null;
    image_hint?: string | null;
};

type DeleteMatchingPayload = {
    matchingId: number | string;
};


const matchingAPI = {

    createMatching(payload: CreateMatchingPayload) {
        const requestBody: {
            matchings: MatchingPayloadItem[];
            skill_listening_speaking?: boolean;
            skill_lang_nature?: boolean;
            skill_reading?: boolean;
            skill_writing?: boolean;
        } = {
            matchings: payload.matchings,
        };

        if (payload.skill_listening_speaking !== undefined) {
            requestBody.skill_listening_speaking = payload.skill_listening_speaking;
        }
        if (payload.skill_lang_nature !== undefined) {
            requestBody.skill_lang_nature = payload.skill_lang_nature;
        }
        if (payload.skill_reading !== undefined) {
            requestBody.skill_reading = payload.skill_reading;
        }
        if (payload.skill_writing !== undefined) {
            requestBody.skill_writing = payload.skill_writing;
        }

        return apiServices
            .post(`/api/game/${payload.gameId}/matchings`, requestBody, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error createMatching:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    getMatchingById(payload: GetMatchingByIdPayload) {
        return apiServices
            .get(`/api/game/${payload.gameId}/matchings`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error getMatchingById:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    getAllMatching() {
        return apiServices
            .get(`/api/matchings`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error getAllMatching:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    updateMatching(payload: UpdateMatchingPayload) {
        const requestBody: {
            keyword?: string;
            matching_word?: string;
            no?: number;
            hint?: string | null;
            sound_keyword?: string | null;
            image_keyword?: string | null;
            sound_matching_word?: string | null;
            image_matching_word?: string | null;
            sound_hint?: string | null;
            image_hint?: string | null;
            skill_listening_speaking?: boolean;
            skill_lang_nature?: boolean;
            skill_reading?: boolean;
            skill_writing?: boolean;
        } = {};

        if (payload.keyword !== undefined) requestBody.keyword = payload.keyword;
        if (payload.matching_word !== undefined) requestBody.matching_word = payload.matching_word;
        if (payload.no !== undefined) requestBody.no = payload.no;
        if (payload.hint !== undefined) requestBody.hint = payload.hint;
        if (payload.sound_keyword !== undefined) requestBody.sound_keyword = payload.sound_keyword;
        if (payload.image_keyword !== undefined) requestBody.image_keyword = payload.image_keyword;
        if (payload.sound_matching_word !== undefined) requestBody.sound_matching_word = payload.sound_matching_word;
        if (payload.image_matching_word !== undefined) requestBody.image_matching_word = payload.image_matching_word;
        if (payload.sound_hint !== undefined) requestBody.sound_hint = payload.sound_hint;
        if (payload.image_hint !== undefined) requestBody.image_hint = payload.image_hint;
        if (payload.skill_listening_speaking !== undefined) {
            requestBody.skill_listening_speaking = payload.skill_listening_speaking;
        }
        if (payload.skill_lang_nature !== undefined) {
            requestBody.skill_lang_nature = payload.skill_lang_nature;
        }
        if (payload.skill_reading !== undefined) {
            requestBody.skill_reading = payload.skill_reading;
        }
        if (payload.skill_writing !== undefined) {
            requestBody.skill_writing = payload.skill_writing;
        }

        return apiServices
            .put(`/api/matchings/${payload.matchingId}`, requestBody, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error updateMatching:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    hardDeleteMatching(payload: DeleteMatchingPayload) {
        return apiServices
            .delete(`/api/matchings/${payload.matchingId}`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error hardDeleteMatching:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    softDeleteMatching(payload: DeleteMatchingPayload) {
        return apiServices
            .patch(`/api/matchings/${payload.matchingId}/soft-delete`, {}, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error softDeleteMatching:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

}

export default matchingAPI;